import React from 'react';

import { SYMBOL_TYPES } from 'shared/constants/map';
import Icon from 'shared/components/presentational/Icons/Icon';

type Props = {
  width: string | number;
  height: string | number;
  type: string;
  className?: string;
};
export default function Symbol({ width, height, type, className }: Props) {
  if (type === SYMBOL_TYPES.BOUTIQUE || type === SYMBOL_TYPES.STAND) {
    return (
      <Icon
        width={width}
        height={height}
        className={className}
        name={'PositionFill'}
      />
    );
  }
  if (type === SYMBOL_TYPES.CLUSTER) {
    return (
      <Icon
        width={width}
        height={height}
        className={className}
        name={'PositionThin'}
      />
    );
  }
  if (type === SYMBOL_TYPES.HOME) {
    return (
      <Icon width={width} height={height} className={className} name={'Home'} />
    );
  }
  if (type === SYMBOL_TYPES.USER) {
    return (
      <Icon
        width={width}
        height={height}
        className={className}
        name={'UserPosition'}
      />
    );
  }
  return (
    <Icon
      width={width}
      height={height}
      className={className}
      name={'Position'}
    />
  );
}
